import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface BillingStatus {
  can_access_app: boolean;
  // 'beta' (K28 BIL-1): an active beta-tester shop with no access-granting
  // subscription. get_shop_billing_status returns it server-side for ALL
  // shop roles, so beta access no longer depends on the manager-only
  // useBetaCheckin hook.
  billing_status: 'internal' | 'alpha' | 'beta' | 'active' | 'trialing' | 'past_due' | 'scheduled' | 'no_subscription';
  plan_key?: string;
  subscription_status?: string;
  trial_ends_at?: string;
  next_billing_date?: string;
  grace_period_end?: string;
  is_in_grace_period?: boolean;
  days_until_lockout?: number;
}

export const useBillingStatus = (shopId?: string) => {
  return useQuery({
    queryKey: ['billing-status', shopId],
    queryFn: async () => {
      if (!shopId) return null;

      const { data, error } = await supabase.rpc('get_shop_billing_status', {
        p_shop_id: shopId,
      });

      if (error) throw error;
      return data?.[0] as BillingStatus | null;
    },
    enabled: !!shopId,
    refetchInterval: 60000,
  });
};
